import { Link } from "react-router-dom";
import type { Work } from "@/types/media";
import { TYPE_LABELS } from "@/types/media";

interface HotRankingProps {
  works: Work[];
}

export default function HotRanking({ works }: HotRankingProps) {
  const list = [...works].sort((a, b) => b.popularity - a.popularity).slice(0, 8);

  return (
    <section className="rounded-lg border border-background-200 bg-background-100 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-600 text-background-50">
          <i className="ri-fire-line text-sm"></i>
        </span>
        <h2 className="font-heading text-lg font-bold text-foreground-950">
          热播排行榜
        </h2>
      </div>

      <ul className="flex flex-col">
        {list.map((work, i) => (
          <li key={work.id}>
            <Link
              to={`/detail/${work.id}`}
              className="group flex items-center gap-3 border-b border-background-200 py-3 last:border-0"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  i < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-12 w-9 shrink-0 overflow-hidden rounded-sm bg-background-200">
                <img
                  src={work.poster}
                  alt={work.title}
                  title={`${work.title} 封面`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h4 className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                  {work.title}
                </h4>
                <div className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                  <span>{TYPE_LABELS[work.type]}</span>
                  <span className="flex items-center gap-0.5 text-accent-600">
                    <i className="ri-star-fill"></i>
                    {work.rating.toFixed(1)}
                  </span>
                </div>
              </div>
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line text-base"></i>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}